if (window.location.pathname === "/collections/all") {
  const params = new URLSearchParams(window.location.search);
  const page = parseInt(params.get("page"));
  if (page > 560) {
    window.location.replace("/collections/all?page=1");
  }
}

document.addEventListener("DOMContentLoaded", function () {
  function isInWebView() {
    var isMobileView = window.matchMedia("(max-width: 767px)").matches;

    // If want to load something different in WebViewApp
    // const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // return userAgent.includes("MyWebViewApp");

    return isMobileView;
    
  }

  if (isInWebView()) {
    document.body.classList.add("in-webview");

    //Find the first .footer_block inside .footer-block-list
    var firstFooterBlock = document.querySelector(
      ".footer__block-list .footer__block"
    );
    if (firstFooterBlock) {
      firstFooterBlock.style.display = "none";
    }

    document.querySelectorAll(".footer__block--links .h6").forEach((header) => {
      // Create the toggle icon
      const toggleIcon = document.createElement("span");
      toggleIcon.className = "toggle-icon";
      toggleIcon.textContent = "+"; // Start with plus
      toggleIcon.style.position = "absolute";
      toggleIcon.style.right = "10px";
      toggleIcon.style.top = "-5px";
      toggleIcon.style.fontSize = "16px";

      header.style.position = "relative";
      header.appendChild(toggleIcon);

      // Set initial hidden content
      const content = header.nextElementSibling;
      if (content && content.tagName.toLowerCase() === "ul") {
        content.style.display = "none";
      }

      // Add click event
      header.addEventListener("click", function () {
        this.classList.toggle("active");

        const content = this.nextElementSibling;
        const icon = this.querySelector(".toggle-icon");

        if (content && content.tagName.toLowerCase() === "ul") {
          if (content.style.display === "block") {
            content.style.display = "none";
            if (icon) icon.textContent = "+";
          } else {
            content.style.display = "block";
            if (icon) icon.textContent = "−"; // change to minus when open
          }
        }
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll(".bottom-nav a");
  links.forEach((link) => {
    if (link.href === window.location.href) {
      link.classList.add("active");
    }
  });
});
